// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_seguridad_usuarios_app.proto (package sextante.plataforma.seguridad.usuarios_app.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_seguridad_usuarios_app.proto.
 */
export const file_plataforma_seguridad_usuarios_app: GenFile = /*@__PURE__*/
  fileDesc("CidwbGF0YWZvcm1hX3NlZ3VyaWRhZF91c3Vhcmlvc19hcHAucHJvdG8SLXNleHRhbnRlLnBsYXRhZm9ybWEuc2VndXJpZGFkLnVzdWFyaW9zX2FwcC52MSIrChVMaXN0Q3VlbnRhc0FwcFJlcXVlc3QSEgoKY2xpZW50ZV9pZBgBIAEoCSJlChZMaXN0Q3VlbnRhc0FwcFJlc3BvbnNlEksKBWl0ZW1zGAEgAygLMjwuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkN1ZW50YUFwcEl0ZW0iYwoNQ3VlbnRhQXBwSXRlbRIKCgJpZBgBIAEoCRIOCgZub21icmUYAiABKAkSDQoFZW1haWwYAyABKAkSEQoJaXNfYWN0aXZvGAQgASgIEhQKDGhhc191c3VhcmlvcxgFIAEoCCKIAQoXR3VhcmRhckN1ZW50YUFwcFJlcXVlc3QSDwoCaWQYASABKAlIAIgBARISCgpjbGllbnRlX2lkGAIgASgJEg4KBm5vbWJyZRgDIAEoCRINCgVlbWFpbBgEIAEoCRIVCghwYXNzd29yZBgFIAEoCUgBiAEBQgUKA19pZEILCglfcGFzc3dvcmQiIAoSQ3VlbnRhQXBwSWRSZXF1ZXN0EgoKAmlkGAEgASgJIhkKF0N1ZW50YUFwcEFjY2lvblJlc3BvbnNlMqIGChxVc3Vhcmlvc0FwcFBsYXRhZm9ybWFTZXJ2aWNlEpwBCg1MaXN0QnlDbGllbnRlEkQuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkxpc3RDdWVudGFzQXBwUmVxdWVzdBpFLnNleHRhbnRlLnBsYXRhZm9ybWEuc2VndXJpZGFkLnVzdWFyaW9zX2FwcC52MS5MaXN0Q3VlbnRhc0FwcFJlc3BvbnNlEo8BCgdHdWFyZGFyEkYuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkd1YXJkYXJDdWVudGFBcHBSZXF1ZXN0Gjwuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkN1ZW50YUFwcEl0ZW0SlAEKB0FjdGl2YXISQS5zZXh0YW50ZS5wbGF0YWZvcm1hLnNlZ3VyaWRhZC51c3Vhcmlvc19hcHAudjEuQ3VlbnRhQXBwSWRSZXF1ZXN0GkYuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkN1ZW50YUFwcEFjY2lvblJlc3BvbnNlEpYBCglJbmFjdGl2YXISQS5zZXh0YW50ZS5wbGF0YWZvcm1hLnNlZ3VyaWRhZC51c3Vhcmlvc19hcHAudjEuQ3VlbnRhQXBwSWRSZXF1ZXN0GkYuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkN1ZW50YUFwcEFjY2lvblJlc3BvbnNlEqABChNSZXN0YWJsZWNlclBhc3N3b3JkEkEuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudXN1YXJpb3NfYXBwLnYxLkN1ZW50YUFwcElkUmVxdWVzdBpGLnNleHRhbnRlLnBsYXRhZm9ybWEuc2VndXJpZGFkLnVzdWFyaW9zX2FwcC52MS5DdWVudGFBcHBBY2Npb25SZXNwb25zZUIWqgITQXBpLkdycGMuUGxhdGFmb3JtYWIGcHJvdG8z");

/**
 * Cliente del que se piden las cuentas.
 *
 * @generated from message sextante.plataforma.seguridad.usuarios_app.v1.ListCuentasAppRequest
 */
export type ListCuentasAppRequest = Message<"sextante.plataforma.seguridad.usuarios_app.v1.ListCuentasAppRequest"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;
};

/**
 * Describes the message sextante.plataforma.seguridad.usuarios_app.v1.ListCuentasAppRequest.
 * Use `create(ListCuentasAppRequestSchema)` to create a new message.
 */
export const ListCuentasAppRequestSchema: GenMessage<ListCuentasAppRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_app, 0);

/**
 * Cuentas del cliente.
 *
 * @generated from message sextante.plataforma.seguridad.usuarios_app.v1.ListCuentasAppResponse
 */
export type ListCuentasAppResponse = Message<"sextante.plataforma.seguridad.usuarios_app.v1.ListCuentasAppResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppItem items = 1;
   */
  items: CuentaAppItem[];
};

/**
 * Describes the message sextante.plataforma.seguridad.usuarios_app.v1.ListCuentasAppResponse.
 * Use `create(ListCuentasAppResponseSchema)` to create a new message.
 */
export const ListCuentasAppResponseSchema: GenMessage<ListCuentasAppResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_app, 1);

/**
 * Solo lo que usa la pestana Usuarios (lista y modal de edicion).
 *
 * @generated from message sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppItem
 */
export type CuentaAppItem = Message<"sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: bool is_activo = 4;
   */
  isActivo: boolean;

  /**
   * true = administra los usuarios del cliente dentro de la app web; lo asigna el backend.
   *
   * @generated from field: bool has_usuarios = 5;
   */
  hasUsuarios: boolean;
};

/**
 * Describes the message sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppItem.
 * Use `create(CuentaAppItemSchema)` to create a new message.
 */
export const CuentaAppItemSchema: GenMessage<CuentaAppItem> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_app, 2);

/**
 * Cuenta a crear o editar.
 *
 * @generated from message sextante.plataforma.seguridad.usuarios_app.v1.GuardarCuentaAppRequest
 */
export type GuardarCuentaAppRequest = Message<"sextante.plataforma.seguridad.usuarios_app.v1.GuardarCuentaAppRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * Solo se aplica al crear: la cuenta no se traslada de cliente al editar.
   *
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * Al crear, ausente = se genera una. Al editar, ausente = no cambia.
   *
   * @generated from field: optional string password = 5;
   */
  password?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.seguridad.usuarios_app.v1.GuardarCuentaAppRequest.
 * Use `create(GuardarCuentaAppRequestSchema)` to create a new message.
 */
export const GuardarCuentaAppRequestSchema: GenMessage<GuardarCuentaAppRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_app, 3);

/**
 * Cuenta sobre la que se actua.
 *
 * @generated from message sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppIdRequest
 */
export type CuentaAppIdRequest = Message<"sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppIdRequest.
 * Use `create(CuentaAppIdRequestSchema)` to create a new message.
 */
export const CuentaAppIdRequestSchema: GenMessage<CuentaAppIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_app, 4);

/**
 * Las acciones no devuelven datos: la pestana vuelve a pedir la lista.
 *
 * @generated from message sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppAccionResponse
 */
export type CuentaAppAccionResponse = Message<"sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.seguridad.usuarios_app.v1.CuentaAppAccionResponse.
 * Use `create(CuentaAppAccionResponseSchema)` to create a new message.
 */
export const CuentaAppAccionResponseSchema: GenMessage<CuentaAppAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_app, 5);

/**
 * Cuentas de la SPA Cliente (DATA AG) de un cliente, en la app Plataforma: menu Clientes, pestana
 * Usuarios. Logica propia del servicio gRPC, sin la capa vieja de servicios. No hay baja: la web no la
 * usa. Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.seguridad.usuarios_app.v1.UsuariosAppPlataformaService
 */
export const UsuariosAppPlataformaService: GenService<{
  /**
   * Cuentas no eliminadas del cliente, las que administran usuarios primero. Un cliente sin cuentas
   * (o inexistente) devuelve la lista vacia.
   *
   * @generated from rpc sextante.plataforma.seguridad.usuarios_app.v1.UsuariosAppPlataformaService.ListByCliente
   */
  listByCliente: {
    methodKind: "unary";
    input: typeof ListCuentasAppRequestSchema;
    output: typeof ListCuentasAppResponseSchema;
  },
  /**
   * Sin id crea (password opcional: sin ella se genera; correo de bienvenida). Con id edita nombre y
   * email; si viene password la cambia, cierra las sesiones y manda correo de credenciales.
   * Validaciones de negocio -> InvalidArgument con el motivo.
   *
   * @generated from rpc sextante.plataforma.seguridad.usuarios_app.v1.UsuariosAppPlataformaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarCuentaAppRequestSchema;
    output: typeof CuentaAppItemSchema;
  },
  /**
   * Reactiva la cuenta. NotFound si no existe o esta eliminada.
   *
   * @generated from rpc sextante.plataforma.seguridad.usuarios_app.v1.UsuariosAppPlataformaService.Activar
   */
  activar: {
    methodKind: "unary";
    input: typeof CuentaAppIdRequestSchema;
    output: typeof CuentaAppAccionResponseSchema;
  },
  /**
   * Suspende la cuenta y cierra sus sesiones (base + cache de sesion).
   *
   * @generated from rpc sextante.plataforma.seguridad.usuarios_app.v1.UsuariosAppPlataformaService.Inactivar
   */
  inactivar: {
    methodKind: "unary";
    input: typeof CuentaAppIdRequestSchema;
    output: typeof CuentaAppAccionResponseSchema;
  },
  /**
   * Genera una contrasena nueva, cierra las sesiones y la envia por correo; nunca la devuelve.
   *
   * @generated from rpc sextante.plataforma.seguridad.usuarios_app.v1.UsuariosAppPlataformaService.RestablecerPassword
   */
  restablecerPassword: {
    methodKind: "unary";
    input: typeof CuentaAppIdRequestSchema;
    output: typeof CuentaAppAccionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_seguridad_usuarios_app, 0);

